const notes = [
  {
    title: 'Accelerate, not replace',
    body: 'AI handles volume — boilerplate, drafts, repetitive transforms. Judgment, architecture, and production trade-offs stay with experienced engineers.',
  },
  {
    title: 'Senior review on every merge',
    body: 'Nothing ships because a model suggested it. Code, schemas, and UX decisions pass human review with the same rigor as any disciplined engineering shop.',
  },
  {
    title: 'Production standards from day one',
    body: 'Observability, security baselines, deployment pipelines, and documentation are part of the scope — not a phase we promise for later.',
  },
]

/**
 * Caution plate — cool white ground, magenta hairline rules only.
 * The land tint is reserved for the chart field, never a full-bleed panel.
 */
export function Notes() {
  return (
    <section id="notes" className="bg-sheet">
      <div className="mx-auto max-w-[100rem] px-6 py-12 lg:px-8 lg:py-16">
        <div className="border-2 border-overprint">
          <div className="border-b-2 border-overprint px-5 py-4 sm:px-7">
            <h2 className="section-title text-ink">How we use AI</h2>
          </div>

          <div className="grid divide-y divide-overprint/40 lg:grid-cols-3 lg:divide-x lg:divide-y-0">
            {notes.map((note) => (
              <article key={note.title} className="px-5 py-6 sm:px-7 lg:py-7">
                <h3 className="entry-title text-ink">{note.title}</h3>
                <p className="mt-3 text-[0.9375rem] leading-relaxed text-ink-muted">
                  {note.body}
                </p>
              </article>
            ))}
          </div>
        </div>

        <p className="mt-5 max-w-3xl text-base leading-relaxed text-ink-muted">
          AI is shop-floor tooling here — a force multiplier inside a process built for
          reliability, never a substitute for accountability.
        </p>
      </div>
    </section>
  )
}
